<section class="section section-dashboard">
    <div class="container">
        <div class="wrapper-content bg-light">
            <app-dashboard-header></app-dashboard-header>
            <div class="row row-padding-10">
                <div class="col-md-auto col-lg-auto col-sm-12">
                    <app-side-nav [config]="navConfig"></app-side-nav>
                </div>
                <div class="col">
                    <div class="content">
                        <app-publisher-dashboard *ngIf="userType === USER_TYPE.PUBLISHER || userType === USER_TYPE.SUB_ACCOUNT"></app-publisher-dashboard>
                        <app-viewer-dashboard *ngIf="userType === USER_TYPE.VIEWER"></app-viewer-dashboard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
